import BaseClient from '../BaseClient';
import type { AxiosPromise } from 'axios';
import type {
    ThreadCategoriesClientInterface,
    ThreadCategoriesResponse,
    ThreadCategoryFormData,
} from './threadCategoriesClient.types';

export default class CorporateThreadCategoriesClient extends BaseClient implements ThreadCategoriesClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getThreadCategories(): AxiosPromise<ThreadCategoriesResponse> {
        const url = `/api/v3/teams/${this.teamId}/thread-categories`;
        return this.makeCoreApiRequest(url, 'get');
    }

    updateThreadCategories(
        data: { categories: ThreadCategoryFormData[] },
        extraConfig?: { cancelKey?: string | symbol }
    ): AxiosPromise<ThreadCategoriesResponse> {
        const url = `/api/v3/teams/${this.teamId}/thread-categories`;
        return this.makeCoreApiRequest(url, 'put', data, null, extraConfig);
    }
}
